package one.healthium.insights.ui.components.items

import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.size
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import one.healthium.insights.domain.models.ContentEntry

@Composable
fun ContentSpace(
    modifier: Modifier = Modifier,
    entry: ContentEntry.Space,
) {
    Spacer(modifier = modifier.size(entry.size.dp))
}